require("./bringoz-timeline-logs-table.scss");

import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {bzIconArrowUp} from "@bringoz/ui/icons";
import {TimelineLog} from "../bringoz-timeline-logs-table-row/bringoz-timeline-logs-table-row.component";

@Component({
  selector: "app-bringoz-timeline-logs-table",
  templateUrl: "./bringoz-timeline-logs-table.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BringozTimelineLogsTableComponent {
  readonly timeline = input<TimelineLog[]>([]);

  readonly sortIcon = bzIconArrowUp;
}
